import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '../selected-rows-status-bar/selected-rows-status-bar'
import { CwTransactionsMarginEffectStatusBarComp } from './cwTransaction-marginEffect-status-bar'
import { TransactionsAmountStatusBarComp } from './transaction-amount-status-bar'
import { TransactionsStatusBarComp } from './transaction-units-status-bar'

export const transactionStatusBarModuleName = 'hlTransactionsStatusBarModule'
export const transactionUnitsStatusBar = 'hlTransactionsStatusBar'
export const transactionAmountsStatusBar = 'hlTransactionAmountsStatusBar'
export const cwTransactionMarginEffectStatusBar =
  'hlCwTransactionMarginEffectStatusBar'
export const selectedRowsStatusBar = 'hlSelectedRowsStatusBar'

export const transactionsStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: selectedRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: transactionUnitsStatusBar,
      align: 'right',
    },
    {
      statusPanel: transactionAmountsStatusBar,
      align: 'right',
    },
  ],
}

export const cwTransactionsStatusBarPanel: { statusPanels: StatusPanelDef[] } =
  {
    statusPanels: [
      {
        statusPanel: selectedRowsStatusBar,
        align: 'left',
      },
      {
        statusPanel: transactionUnitsStatusBar,
        align: 'right',
      },
      {
        statusPanel: cwTransactionMarginEffectStatusBar,
        align: 'right',
      },
      {
        statusPanel: transactionAmountsStatusBar,
        align: 'right',
      },
    ],
  }

export const TransactionsStatusBarModule: Module = {
  moduleName: transactionStatusBarModuleName,
  userComponents: [
    {
      componentName: selectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
    {
      componentName: transactionUnitsStatusBar,
      componentClass: TransactionsStatusBarComp,
    },
    {
      componentName: cwTransactionMarginEffectStatusBar,
      componentClass: CwTransactionsMarginEffectStatusBarComp,
    },
    {
      componentName: transactionAmountsStatusBar,
      componentClass: TransactionsAmountStatusBarComp,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
